import { $t as lib$t } from '@teachino/shared-i18n';

export const $t = lib$t;

export default defineNuxtPlugin(() => {
  return {
    provide: {
      /*
        string: the id of the string that should get displayed using locales/de.json file
        placeholders: an array of objects
        {{object.id}} in the localised string will be replaced with {{object.value}}

        t is available as $t() in vue html code; and can be made available via
          import { useNuxtApp } from '#imports';
          const { $t } = useNuxtApp();
        in vue setup code
       */
      t: $t,
    },
  };
});
